<div>
    <h5 class="b-bottom pb-3">Exam Result</h5>
    <div class="cont d-flex flex-column align-items-center mt-4">
        <div class="d-flex max-w mb-3 m-box ps-2">
            <div class="c-box d-flex">
                <div class="c-img" [appBackgroundImg]="resultData.course_data.image" iType="course">
                  
                </div>
                <div class="ps-lg-3 ps-3 d-flex f-box">
                    <h5>{{resultData.course_data.title}}</h5>
                    <div class="c-dep steel-blue">{{resultData.course_data.department}}</div>
                </div>
            </div>
            <div class="e-box" >
                <img class="pe-2" src="assets/images/object_icons/exam.png">
                <h5 class="mb-0 text-bold d-flex align-items-center justify-content-end">{{resultData.exam_details.title}}</h5>
            </div>
        </div>
        <div class="r-box d-box max-w flex-grow-1 p-3 p-lg-4 p-xl-5">
            <div *ngIf="resultData.is_pass==0" style="display: contents;">
                <div class="r-up">
                    <div class="r-per text-bold d-box">{{resultData.total_percentage}}%</div>
                </div>
                <div class="r-msg mt-3 mt-lg-4 text-center">Unfortunately, You were unsuccessful</div>
            </div>
            <div *ngIf="resultData.is_pass==1" class="d-flex flex-column align-items-center">
                <div class="medal">
                    <img src="assets/images/object_icons/medal_ic.png" class="img-fluid">
                </div>
                <div class="percentage d-flex text-center text-bold">
                    {{resultData.total_percentage}}% 
                  
                </div>
                <div class="status text-bold">
                    Bravo, you've made it to success!
                </div>
            </div>
            <div class="d-flex mt-lg-4 flex-wrap align-items-center justify-content-center">
                <div class="t-box d-box mt-3">
                    <div class="icon-div ms-4 me-4">
                        <img src="assets/images/object_icons/total-quest.png" class="img-fluid">
                    </div>
                    <div>
                        <h3 class="primary-color m-0">{{resultData.total}}</h3>
                        <div class="steel-blue">Total Question</div>
                    </div>
                </div>
                <div class="t-box d-box mt-3">
                    <div class="icon-div ms-4 me-2">
                        <img src="assets/images/object_icons/right-answer.png" class="img-fluid">
                    </div>
                    <div>
                        <h3 class="r-ans">{{resultData.right_ans }}</h3>
                        <div class="steel-blue ">Right Answer</div>
                    </div>
                </div>
                <div class="t-box d-box mt-3 d-flex">
                    <div class="icon-div ms-4 me-2">
                        <img src="assets/images/object_icons/wrong-answer.png" class="img-fluid">
                    </div>
                    <div>
                        <h3 class="r-wrong">{{resultData.wrong_ans }}</h3>
                        <div class="steel-blue ">Wrong Answer</div>
                    </div>
                </div>
            </div>
            <div class="c-btn d-flex align-items-center justify-content-center ">
                <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onExamList()">Go to Exam List</button>
            </div>
        </div>
    </div>
</div>